import { render, staticRenderFns } from "./BetgameEditMatchdayWinners.vue?vue&type=template&id=e1ce4056&scoped=true"
import script from "./BetgameEditMatchdayWinners.vue?vue&type=script&lang=js"
export * from "./BetgameEditMatchdayWinners.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditMatchdayWinners.vue?vue&type=style&index=0&id=e1ce4056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ce4056",
  null
  
)

export default component.exports